import React from 'react';
import { Route, Routes } from 'react-router-dom';
import './index.css';
import ScrollToTop from './components/ScrollToTop';
import CaseStudyPage from './components/CaseStudyPage';
import HomePage from './pages/HomePage';

const App: React.FC = () => {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/work/:slug" element={<CaseStudyPage />} />
      </Routes>
    </>
  );
};

export default App;
